import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ptBR from './locales/pt-BR.json'
import ptPT from './locales/pt-PT.json'
import es from './locales/es.json'
import en from './locales/en.json'
import { DEFAULT_LANGUAGE, SUPPORTED } from './languages'

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { translation: ptBR },
    'pt-PT': { translation: ptPT },
    es: { translation: es },
    en: { translation: en },
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: {
    'pt-PT': ['pt-BR', 'en'],
    es: ['en', 'pt-BR'],
    en: ['pt-BR'],
    default: ['pt-BR'],
  },
  supportedLngs: SUPPORTED,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  returnEmptyString: false,
})

export default i18n
